import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=79eeaa76&scoped=true&"
import script from "./Task.vue?vue&type=script&lang=js&"
export * from "./Task.vue?vue&type=script&lang=js&"
import style0 from "./Task.vue?vue&type=style&index=0&id=79eeaa76&lang=scss&scoped=true&"
import style1 from "./Task.vue?vue&type=style&index=1&id=79eeaa76&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eeaa76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79eeaa76')) {
      api.createRecord('79eeaa76', component.options)
    } else {
      api.reload('79eeaa76', component.options)
    }
    module.hot.accept("./Task.vue?vue&type=template&id=79eeaa76&scoped=true&", function () {
      api.rerender('79eeaa76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/Edit/Task.vue"
export default component.exports